class BaseController {

}

export {
  BaseController
}
